/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatAuthorizedMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTHORIZED);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ChatAuthorizedMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.prototype.processMessage = function(message) {
	if(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_TYPE) == com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_VIRTUAL_AGENT) {
		com.inq.flash.client.control.PersistenceManager.SetValue(VIRTUAL_AGENT, 1, true, true);
	}
	this.getController().getChat().setHasAuthorized(true);
	var isAsync = message.getPropertyAsBoolean(com.inq.flash.client.data.MessageFields.KEY_CONFIG_IS_ASYNC_ENGAGEMENT);
	if (isAsync !== null) {
		this.getController().getChat().setAsyncChat(isAsync);
		com.inq.flash.client.control.FlashPeer.setAsyncChat(isAsync);
	}
	/*
	 * To support customer API "Inq.API.get('conversationID');" on our
	 * CI framework we need to pass active conversation ID to the CI,
	 * Normally CI fill conversationID when parse conversation transcript
	 * but when it is first conversation we do not have any transcript so
	 * in this case we generate new id inside Persistence Service and
	 * pass it to the CI as part of chat.authorized message.
	 */
	var conversationID = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CONVERSATION_ID);
	if (conversationID) {
		com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationID);
	}

	this.getController().sendFirstQueuedMessage(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TIME_LOG));
	this.getController().setQueueMessages();

	com.inq.flash.client.control.Incrementality.onChatroomReady();
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatAuthorizedMessageHandler;
